import React, { ChangeEvent, useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import CRMApi from '../../../../../Api/CRM/CRMApi';
import GetAllLanguagesResponse from '../../../../../Api/CRM/Responses/LanguagesResponse';
import CasinoCRMApi from '../../../../../casino/Api/CRM/CasinoCRMApi';
import Loader from '../../../../elements/Loader';
import FormGroupText from '../../../../elements/formElements/FormGroupText';
import SubmitButton from '../../../../elements/formElements/SubmitButton';
import { CASINO_GAME_CREATORS } from '../../Helpers/CrmUrls';

import { UpdateGameCreatorSeoRequest } from 'casino/Api/CRM/Requests/UpdateGameCreatorSeoRequest';
import SweetAlert from 'crm/elements/alerts/SweetAlert';
import handleValidationErrors from 'crm/helpers/ResponseErrorHelper';
import useNumberParams from 'crm/hooks/useNumberParams';

export default function GameCreatorSeo() {
    const history = useHistory();
    const { id } = useNumberParams();
    const [isLoading, setIsLoading] = useState(true);
    const [languages, setLanguages] = useState<GetAllLanguagesResponse>([]);
    const [translations, setTranslations] = useState<UpdateGameCreatorSeoRequest>({});
    const [errors, setErrors] = useState({});

    async function loadState() {
        setLanguages(await CRMApi.languages.getAll());

        const translationsFromApi = await CasinoCRMApi.seoSettingsApi.show(id);
        const translationsFormatted = {};
        translationsFromApi.forEach((translation) => {
            translationsFormatted[translation.language_id] = {
                ...translationsFormatted[translation.language_id],
                [translation.name]: translation.content,
                id,
            };
        });
        setTranslations(translationsFormatted);
    }

    useEffect(() => {
        setIsLoading(true);
        loadState();
        setIsLoading(false);
    }, []);

    const handleTranslationChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const languageId = parseInt(e.target.getAttribute('data-language-id'));

        setTranslations({
            ...translations,
            [languageId]: {
                ...translations[languageId],
                [name]: value,
                id,
            },
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        CasinoCRMApi.seoSettingsApi
            .update(translations)
            .then(() => {
                SweetAlert.success('Game SEO updated correctly').then(() => {
                    history.push({ pathname: CASINO_GAME_CREATORS });
                });
            })
            .catch((error) => {
                handleValidationErrors(error, setErrors);
            });
    };

    const getContent = () => {
        return (
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title text-capitalize font-weight-bold">Game seo settings</h4>
                    <p>Available dynamic values: gameName, providerName</p>
                    <form>
                        {languages.length > 0 &&
                            languages.map((language) => {
                                return (
                                    <div key={language.id}>
                                        <FormGroupText
                                            name="title"
                                            value={translations?.[language.id]?.title}
                                            handleChange={handleTranslationChange}
                                            label={`${language.name} meta title`}
                                            error={errors?.[`${language.id}.title`]}
                                            data-language-id={language.id}
                                        />
                                        <FormGroupText
                                            name="description"
                                            value={translations?.[language.id]?.description}
                                            handleChange={handleTranslationChange}
                                            label={`${language.name} meta description`}
                                            error={errors?.[`${language.id}.description`]}
                                            data-language-id={language.id}
                                        />
                                    </div>
                                );
                            })}
                        <SubmitButton label="Update" onClick={handleSubmit} />
                    </form>
                </div>
            </div>
        );
    };

    return <Loader loading={isLoading} content={getContent} />;
}
